<template>
  <div class="form-input-wrapper">
    <label class="form-label" :for="id">
      <span>{{ label }}</span
      ><span v-if="required">*</span>
    </label>
    <input
      :id="id"
      :class="['form-input',invalid ? 'invalid':'']"
      type="text"
      :name="name"
      v-model="value"
      @input="is_troskovnik ? $store.state.shared_input_value=value : ''"
      :required="required"
      :disabled="disabled"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default {
  props: ["name", "label", "id", "required", "base", "invalid","disabled","is_edit", "placeholder","is_troskovnik"],
  data() {
    return {
      value: "",
      inputType: "",
      pr_broj_predmeta: "",
      pr_ime_stranke: "",
      pr_ime_protustranke: "",
    };
  },
  methods: {
    // setBrojPredmeta() {
    //   if (typeof(this.base) == "string") {
    //     this.value = this.base;
    //   }
    // },
    prijedlogBrojPredmeta() {
      this.pr_broj_predmeta = this.$store.state.ime_predmeta.broj_predmeta;
    },
  },

  watch: {
    value:function () {
      if (this.inputType == 'broj-predmeta' && !this.is_edit) {
        this.$store.state.ime_predmeta.broj_predmeta = this.value
      }
    },
    "$store.state.ime_predmeta.broj_predmeta": {
      handler: function (broj_predmeta) {
        if (this.inputType == "ime-predmeta" && !this.is_edit) {
          this.value =
            broj_predmeta +
            " " +
            this.pr_ime_stranke +
            " - " +
            this.pr_ime_protustranke;
          this.pr_broj_predmeta = broj_predmeta;
        }
      },
    },
    "$store.state.ime_predmeta.ime_stranke": {
      handler: function (ime_stranke) {
        if (this.inputType == "ime-predmeta" && !this.is_edit) {
          this.value =
            this.pr_broj_predmeta +
            " " +
            ime_stranke +
            " - " +
            this.pr_ime_protustranke;
          this.pr_ime_stranke = ime_stranke;
        }
      },
    },
    "$store.state.ime_predmeta.ime_protustranke": {
      handler: function (ime_protustranke) {
        if (this.inputType == "ime-predmeta" && !this.is_edit) {
          this.value =
            this.pr_broj_predmeta +
            " " +
            this.pr_ime_stranke +
            " - " +
            ime_protustranke;
          this.pr_ime_protustranke = ime_protustranke;
        }
      },
    },
    "$store.state.shared_input_value":{
      handler:function () {
        if (this.is_troskovnik) {
          this.value = this.$store.state.shared_input_value;
        }
      }
    }
  },

  mounted() {
    let vm = this;
    // this.setBrojPredmeta();
    vm.$nextTick(function () {
        this.inputType = vm.id;
        // setTimeout(this.setBrojPredmeta, 1000);
        if (!this.is_edit) {
          setTimeout(this.prijedlogBrojPredmeta, 1000);
        }        
    });
  },
};
</script>


